import React, { PropsWithChildren } from "react";

export const RetryIcon: React.FC<PropsWithChildren<React.SVGProps<SVGSVGElement>>> = (props) => (
  <svg width={48} height={48} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M38.9763 9.28125V16.3533H31.9062H38.9763"
      stroke="currentColor"
      strokeWidth={2.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M38.054 16.35C35.34 11.376 30.064 8 24 8C15.164 8 8 15.164 8 24C8 32.836 15.164 40 24 40C32.836 40 40 32.836 40 24"
      stroke="currentColor"
      strokeWidth={2.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
